/* eslint-disable @typescript-eslint/naming-convention */
export enum AmplifyTypesEnum {
    All = 'All',
    Newsroom = 'Newsroom',
    Recent = 'Recent',
    Newswire = 'Newswire',
}
